const API_URL = process.env.API_URL || "https://api.spanish-verb-conjugator.com";

const fetchSuggestions = async (text) => {
  const response = await fetch(`${API_URL}/api/v1/autosuggestions`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ query: text }),
  });
  const data = await response.json();
  return data;
}

const fetchConjugations = async (verb) => {
  const response = await fetch(`${API_URL}/api/v1/conjugations`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ verb: verb }),
  });
  const data = await response.json();
  return data;
}

const apiService = {
  fetchSuggestions,
  fetchConjugations,
};

export default apiService;
